import { Href, useLocalSearchParams, useRouter } from 'expo-router';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import {
  FlowReturnRouteKey,
  flowReturnRoutesAtom,
} from 'shared/state/FlowReturnRouteAtoms';

export const FLOW_RETURN_ROUTE_PARAM = 'hasFlowReturnRoute';

export const useClearFlowReturnRouteOnUnregisteredEntry = (
  flow: FlowReturnRouteKey,
) => {
  const params = useLocalSearchParams<{
    [FLOW_RETURN_ROUTE_PARAM]?: string;
  }>();
  const setReturnRoutes = useSetAtom(flowReturnRoutesAtom);
  const isRegisteredEntry = params[FLOW_RETURN_ROUTE_PARAM] === 'true';

  useEffect(() => {
    if (!isRegisteredEntry) {
      setReturnRoutes((routes) => ({ ...routes, [flow]: undefined }));
    }
  }, [flow, isRegisteredEntry, setReturnRoutes]);
};

const useFlowReturnRoute = (flow: FlowReturnRouteKey) => {
  const router = useRouter();
  const [returnRoutes, setReturnRoutes] = useAtom(flowReturnRoutesAtom);
  const returnRoute = returnRoutes[flow];

  const registerReturnRoute = (route: Href) => {
    setReturnRoutes((routes) => ({ ...routes, [flow]: route }));
  };

  const clearReturnRoute = () => {
    setReturnRoutes((routes) => ({ ...routes, [flow]: undefined }));
  };

  const exitToReturnRoute = (): boolean => {
    if (!returnRoute) {
      return false;
    }

    clearReturnRoute();
    router.dismissTo(returnRoute);
    return true;
  };

  return { registerReturnRoute, clearReturnRoute, exitToReturnRoute };
};

export default useFlowReturnRoute;
